import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { KYMW9002Component } from './kymw9002.component';
import { GetAuthorityComboBoxValueService } from './api-services/get-authority-combo-box-value.service';
import { GetUserInfomationDetailService } from './api-services/get-user-infomation-detail.service';
import { RegistUserService } from './api-services/regist-user.service';
import { UpdateUserService } from './api-services/update-user.service';

/**
 * ユーザー情報詳細画面 モジュール設定クラス
 *
 * @export KYMW9002Module
 * @class KYMW9002Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
  ],
  declarations: [
    KYMW9002Component,
  ],
  providers: [
    GetAuthorityComboBoxValueService,
    GetUserInfomationDetailService,
    RegistUserService,
    UpdateUserService,
  ],
})
export class KYMW9002Module {

}
